import Antd, { message } from "ant-design-vue"
import "ant-design-vue/dist/antd.css"
import axios from "axios"
import "babel-polyfill"
import * as echarts from "echarts"
import base64 from "js-base64"
import moment from "moment"
import Distpicker from "v-distpicker"
import Vue from "vue"
import { VueJsonp } from "vue-jsonp"
import "../src/assets/font/iconfont.css"
import reg from "../src/common/reg"
import App from "./App.vue"
import chinaMap from "./assets/china.json"
import "./assets/css/common.scss"
import db from "./common/localstorage"
import request from "./common/request"
import tusUpload from "./common/tusUpload"
import HConfirm from "./components/common/confirm.vue"
import DragModal from "./components/common/dragModal/dragModal.vue"
import PageModel from "./components/common/pageModel.vue"
import UploadContainer from "./components/common/upload/container/container.vue"
import FileItem from "./components/common/upload/fileItem/fileItem.vue"
import UploadBtn from "./components/common/upload/uploadBtn/uploadBtn.vue"
import "./directives/auth"
import router from "./router"
import store from "./store/index"
require("../src/assets/font/iconfont.js")

Vue.component("v-distpicker", Distpicker)

message.config({
  top: `100px`,
  duration: 3,
  maxCount: 1
})
const uploadModel = {
  install: function(Vue) {
    Vue.component("UploadContainer", UploadContainer)
  }
}
const FileItemModel = {
  install: function(Vue) {
    Vue.component("FileItem", FileItem)
  }
}
const UploadBtnModel = {
  install: function(Vue) {
    Vue.component("UploadBtn", UploadBtn)
  }
}
const fullpageModel = {
  install: function(Vue) {
    Vue.component("PageModel", PageModel)
  }
}
const dragModal = {
  install: function(Vue) {
    Vue.component("DragModal", DragModal)
  }
}
const HConfirmModel = {
  install: function(Vue) {
    Vue.component("HConfirm", HConfirm)
  }
}
Vue.config.productionTip = false
Vue.use(fullpageModel)
Vue.use(dragModal)
Vue.use(HConfirmModel)
Vue.use(uploadModel)
Vue.use(FileItemModel)
Vue.use(UploadBtnModel)
Vue.use(Antd)
Vue.use(VueJsonp)
// Vue.use(db)
Vue.use({
  install(Vue) {
    Vue.prototype.$db = db
  }
})
Vue.prototype.$echarts = echarts
echarts.registerMap("china", { geoJSON: chinaMap })
Vue.prototype.$post = request.post
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload
Vue.prototype.$moment = moment
Vue.prototype.$tusUpload = tusUpload
Vue.prototype.$base64 = base64.Base64
Vue.prototype.$axios = axios
Vue.prototype.regx = reg
moment.locale("zh-cn")

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
